import axios from "axios";
import { BASE_URL } from "../../../constants";

export function createCustomerAndOrder(requestPayload) {
  const url = `${BASE_URL}/customer`;

  return axios.post(url, requestPayload);
}

export function initiateDownPayment(keys) {
  const url = `${BASE_URL}/chargedownpayment`;

  return axios.post(url, keys);
}
export function fetchOrderStatus(orderId) {
  const url = `${BASE_URL}/reservations/status`;

  return axios.post(url, orderId);
}



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/api.js